module.exports = __webpack_public_path__ + "img/detail.aed4a085.png";